import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'parseListingLinks',
  standalone: true,
})
export class ParseListingLinksPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string): SafeHtml {
    if (!text) {
      return '';
    }

    const linkPattern = /\[LISTING:([a-f0-9-]+):([a-z-]+):([^\]]+)\]/gi;

    const transformedText = text.replace(
      linkPattern,
      (match, id, subcategory, title) => {
        return `<a href="/listing-details/${subcategory}/${id}" class="listing-link" target="_blank">${title}</a>`;
      }
    );

    return this.sanitizer.bypassSecurityTrustHtml(transformedText);
  }
}
